import { inject,  } from '@angular/core';
import { CanActivateFn, Router,  } from '@angular/router';
import './util/rxjs';
import { ConfigurationService } from './configuration.service';

export const canActivatePortal: CanActivateFn = () => {
  const router = inject(Router);
  return inject(ConfigurationService).getLoginConfig().map(config => {
      if (!config.portalEnabled) {
        router.navigate(['/no-access']);
        return false;
      }
      return true;
    });
  }
